import { useTranslation } from "react-i18next";
import { Button, Form, Icon, Input, Modal } from "semantic-ui-react";

import { ReplacementOrderTable } from "modules/AppointmentDetails/components/VehicleTyres/components/TyreTable/components/ReplacementOrderModal/components";
import { useTyreReplacementOrder } from "modules/AppointmentDetails/components/VehicleTyres/components/TyreTable/components/ReplacementOrderModal/hooks";
import { hasQuantityExceedingStock } from "modules/AppointmentDetails/components/VehicleTyres/utils";

import type { Appointment, DealerLocation, VehicleTyreReplacement } from "models";
import type { FormEvent } from "react";

type ReplacementOrderModalProps = {
  existingReplacements: VehicleTyreReplacement[];
  location: DealerLocation | undefined;
  open: boolean;
  appointment: Appointment;
  onClose: () => void;
};

export const ReplacementOrderModal = ({ existingReplacements, location, open, appointment, onClose }: ReplacementOrderModalProps) => {
  const { t } = useTranslation();

  const { replacementOrders, isFetchingStock, ref5, ref6, handleInputChange, handleQuantityUpdate, handlePlaceOrders, isOrdering } = useTyreReplacementOrder({
    location,
    existingReplacements,
    appointment,
    onClose,
    open
  });

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    handlePlaceOrders();
  };

  return (
    <Modal className="TyreReplacementModal" closeOnEscape size="fullscreen" open={open} onClose={onClose} closeOnDimmerClick>
      <Modal.Header>
        {t("v8_place_order", "Place Order")}

        <Button className="modal-close-btn" basic onClick={onClose}>
          <Icon className="xmark grey" />
        </Button>
      </Modal.Header>
      <Modal.Content scrolling className="modal-content-container">
        <Form onSubmit={handleSubmit}>
          <Form.Group>
            {location?.is_tyre_team_enabled && (
              <Form.Field width={8}>
                <Input
                  name="ref5"
                  value={ref5}
                  onChange={handleInputChange}
                  icon={<Icon className="pencil square order-ref-icon" />}
                  iconPosition="left"
                  placeholder={t("v8_packing_slip_reference", "Packing slip / Invoice reference")}
                />
              </Form.Field>
            )}
            <Form.Field width={location?.is_tyre_team_enabled ? 8 : 16}>
              <Input
                name="ref6"
                value={ref6}
                onChange={handleInputChange}
                icon={<Icon className="pencil square order-ref-icon" />}
                iconPosition="left"
                placeholder={t("v8_packing_slip_reference", "Packing slip / Invoice reference")}
              />
            </Form.Field>
          </Form.Group>

          <ReplacementOrderTable location={location} replacementOrders={replacementOrders} loading={isFetchingStock} handleQuantityUpdate={handleQuantityUpdate} />
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button
          color="green"
          type="button"
          disabled={isFetchingStock || replacementOrders.every(item => item.quantity < 1) || replacementOrders.some(o => hasQuantityExceedingStock(o.stock, o.quantity))}
          loading={isFetchingStock || isOrdering}
          onClick={handlePlaceOrders}
        >
          {t("v8_order", "Order")}
          <Icon className="check" />
        </Button>
      </Modal.Actions>
    </Modal>
  );
};
